const frameImages = {
  'Gold': 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-gold_78a94671-4595-4552-a7d9-68f780307f1f.png?v=1739214696',
  'Brown': 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-brown_87a233cc-c84d-463f-bd00-ec1107812378.png?v=1739214696',
  'Oak': 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-oak_ed6c9c02-05f5-48ec-9adc-45b9e03750af.png?v=1739214696',
  'Silver': 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-silver_25821ae4-2ead-45e6-898d-d91874e89943.png?v=1739214696',
  'Black': 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-black_4637193b-f661-4b4e-98f9-c67d418093da.png?v=1739214696',
  'White': 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-white_a266ee0d-4989-4359-a984-f600b6c2ee22.png?v=1739214696',
  'None': 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-none_5d6e2be3-3c2d-4d19-8113-dad5d230d97e.png?v=1739214696'
};

// Function to update frame image based on selected variant
function updateFrameImage(variantName) {
  const frameImage = document.querySelector('.frame-preview-image');
  if (frameImage && frameImages[variantName]) {
    frameImage.src = frameImages[variantName];
  }
}

// Listen for variant changes
document.addEventListener('variant:changed', function(event) {
  const variant = event.detail.variant;
  if (variant && variant.option1) { // Assuming frame selection is the first option
    updateFrameImage(variant.option1);
  }
});

// Add swatch images to variant selectors
function initializeSwatchImages() {
  const swatchButtons = document.querySelectorAll('.product-form__input input[type="radio"]');
  
  swatchButtons.forEach(button => {
    const variantTitle = button.value;
    if (frameImages[variantTitle]) {
      const label = button.parentElement;
      if (label && label.classList.contains('product-form__radio')) {
        // Create swatch image container
        const swatchImage = document.createElement('img');
        swatchImage.src = frameImages[variantTitle];
        swatchImage.alt = variantTitle;
        swatchImage.classList.add('swatch-image');
        
        // Insert image before the existing content
        label.insertBefore(swatchImage, label.firstChild);
      }
    }
  });
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', initializeSwatchImages); 